import { Component, OnInit } from '@angular/core';

import firebase from "firebase/app";

@Component({
  selector: 'app-page-target',
  templateUrl: './page-target.component.html',
  styleUrls: ['./page-target.component.sass']
})
export class PageTargetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
